import { atom } from "jotai";

export const adControlsHaveFocusAtom = atom(false);
